module.exports = __webpack_public_path__ + "media/sub7-2-1.556aa883.mp4";